import React from 'react'
import { Form, Input } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'

/**
 * New password and its confirmation, shared by every step that sets a password.
 *
 * The hint describes Cognito's default password policy, which Tracer's user
 * pools use. Cognito still enforces the policy itself, and its own description
 * of what is wrong is shown if it rejects a password.
 */
export default function NewPasswordFields({ autoFocus = false }) {
  const intl = useIntl()

  return (
    <>
      <Form.Item
        name="new_password"
        label={<FormattedMessage id="auth.newPasswordLabel" />}
        extra={<FormattedMessage id="auth.passwordPolicyHint" />}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: 'auth.newPasswordFieldRequired',
            }),
          },
        ]}
      >
        <Input.Password
          data-testid="login-new-password"
          placeholder={intl.formatMessage({
            id: 'auth.newPasswordPlaceholder',
          })}
          autoComplete="new-password"
          autoFocus={autoFocus}
        />
      </Form.Item>

      <Form.Item
        name="confirm_password"
        label={<FormattedMessage id="auth.confirmPasswordLabel" />}
        dependencies={['new_password']}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: 'auth.newPasswordFieldRequired',
            }),
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('new_password') === value) {
                return Promise.resolve()
              }
              return Promise.reject(
                new Error(
                  intl.formatMessage({ id: 'auth.passwordsDoNotMatch' }),
                ),
              )
            },
          }),
        ]}
      >
        <Input.Password
          data-testid="login-confirm-password"
          placeholder={intl.formatMessage({
            id: 'auth.confirmPasswordPlaceholder',
          })}
          autoComplete="new-password"
        />
      </Form.Item>
    </>
  )
}
